import { render } from "./slides_iframe_tc_00overview.vue?vue&type=template&id=1d0d4776&scoped=true"
import script from "./slides_iframe_tc_00overview.vue?vue&type=script&lang=js"
export * from "./slides_iframe_tc_00overview.vue?vue&type=script&lang=js"

import "./slides_iframe_tc_00overview.vue?vue&type=style&index=0&id=1d0d4776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0d4776"]])

export default __exports__